// This file is auto-generated by @hey-api/openapi-ts

export const CardStatesEnum = {
    NOT_ISSUED: 'NOT_ISSUED',
    ACTIVE: 'ACTIVE',
    BLOCKED: 'BLOCKED',
    EXPIRED: 'EXPIRED',
    IN_PROGRESS: 'IN_PROGRESS',
    TOKENIZED: 'TOKENIZED'
} as const;

export type CardStatesEnum = typeof CardStatesEnum[keyof typeof CardStatesEnum];
